import { useState, useEffect } from 'react';
import { PRINT_TYPE_KEY } from '../../../utils/storageKeys';

export const usePrintType = () => {
  const [printType, setPrintType] = useState(() => {
    return localStorage.getItem(PRINT_TYPE_KEY) || "";
  });
  const [printTypeModalOpen, setPrintTypeModalOpen] = useState(false);
  const [pendingPrintType, setPendingPrintType] = useState(printType || "");

  useEffect(() => {
    if (!printType) {
      setPrintTypeModalOpen(true);
    }
  }, [printType]);

  const handleSavePrintType = () => {
    if (pendingPrintType) {
      setPrintType(pendingPrintType);
      localStorage.setItem(PRINT_TYPE_KEY, pendingPrintType);
      setPrintTypeModalOpen(false);
    }
  };

  const handleOpenPrintTypeModal = () => {
    setPendingPrintType(printType || "");
    setPrintTypeModalOpen(true);
  };

  return {
    printType,
    printTypeModalOpen,
    pendingPrintType,
    setPendingPrintType,
    handleSavePrintType,
    handleOpenPrintTypeModal,
  };
};